import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdEditInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm, RenderItem } from "interfaces/schemaDB";
import { config } from "config";
import { useSchemaDB } from "hooks/useSchemaDB";
import EditBV from "./EditBibliotecaVirtual";
import Cw8Edit from "components/cw8/Cw8Edit";
// import InfografiaEdit from "./editInfografias";
// import { RenderItem } from 'src/interfaces/schemaDB';

export const BVEdit: React.FC<IResourceComponentsProps> = () => {
  const resourceLabel: string = "General";
  const resourceName: string = "bibliotecaVirtual";
  const { id } = useForm();

  const childrenForms: ChildForm[] = [
    {
      resourceName: "autorXDocumento",
      title: "Autores",
      field: "axd_id_doc",
      createModal: true,
      editModal: true,
      showCards: false,
    }
  ];

  return (
    <EditBV
      resourceLabel={resourceLabel}
      resourceName={resourceName}
      id={id}
      childrenForms={childrenForms}
    ></EditBV>
  );
};
